import { useQuery } from '@tanstack/react-query'
import { DealTeamTriggerHistorySection } from '@viapeople/components'
import { useState } from 'react'
import { trpc } from '../../utils/trpc'

interface TriggerHistorySectionProps {
	organizationId: string
}

const PER_PAGE = 10

export function TriggerHistorySection({ organizationId }: TriggerHistorySectionProps) {
	const [enabled, setEnabled] = useState(false)
	const [page, setPage] = useState(1)

	const { data, isLoading, isError } = useQuery({
		...trpc.admin.dealTeam.listTriggerLogs.queryOptions({ organizationId, page, perPage: PER_PAGE }),
		enabled: enabled && !!organizationId,
	})

	return (
		<DealTeamTriggerHistorySection
			logs={data?.data ?? []}
			isLoading={isLoading}
			isError={isError}
			onExpandedChange={(next) => {
				setEnabled(next)
				if (!next) setPage(1)
			}}
			page={page}
			perPage={PER_PAGE}
			total={data?.meta.total ?? 0}
			onPageChange={setPage}
		/>
	)
}
